import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";;

const ProjectitemShowComponent = (props) => {

  const {t} = props;
  const params = useParams();
  const id = props.id || params.id;
  const action = props.action || params.action;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [projectStatuses, setProjectStatuses] = useState([]);
  const formatDateValue = window.App?.formatDateValue;

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const currentStatus = projectStatuses.find(
    item => item.id === formData?.project_status?.id
  );

  const statusColor = currentStatus?.color || '#883cae';

  useEffect(() => {
    if (currentStatus?.color) {
      props?.onStatusColorLoaded?.(currentStatus.color);
    }
  }, [currentStatus?.color]);

  useEffect(() => {
    apiCall('get', '/api/v2/project-status?' + JSON.stringify({
      first: 0,
      rows: 9999,
      page: 0,
    }))
      .then(response => {
        setProjectStatuses(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  // useEffect(() => {
  //   if (id && action === 'read') {
  //     setLoading(true);
  //     apiCall('get', '/api/v2/project/' + id)
  //       .then(response => {
  //         setFormData(response.data.data)
  //         props?.onLoaded?.(response.data.data);
  //       })
  //       .catch(error => {
  //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       })
  //   }
  // }, [window.App.state.rerenderProjectShow, id])

  useEffect(() => {
    if (id && action === 'read') {
      setLoading(true);
      apiCall('get', '/api/v2/project-item/' + id)
        .then(projectItemResponse => {
          const projectId = projectItemResponse?.data?.data?.project?.id;
          if (!projectId) {
            return;
          }
          return apiCall('get', '/api/v2/project/' + projectId);
        })
        .then(projectResponse => {
          setFormData(projectResponse.data.data);
          props?.onLoaded?.(projectResponse.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [window.App.state.rerenderProjectShow, id]);

  return (
    <div
      className={"project-item-form widget status-color-block"}
      style={{'--status-color': statusColor}}
    >
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="last_name">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {formData?.project_status?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="first_name">{t('projectNumber')}</label>
            <span className="p-d-block fake-input">
              {formData.project_number}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnPartner')}</label>
            <span className="p-d-block fake-input">
              {formData.partner?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnCustomer3')}</label>
            <span className="p-d-block fake-input">
              {formData.partner?.name}
            </span>
          </div>
        </div>
        {formData?.deadline &&
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="deadline.name">{t('columnDeadline')}</label>
              <span className="p-d-block fake-input">
                {formatDateValue?.(formData?.deadline) || <span style={{color: '#a8a8a8'}}>?</span>}
              </span>
            </div>
          </div>
        }
        {/* <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="has_subcontractor">{t('columnSubcontractor')}</label>
            <span className="p-d-block fake-input">
              {formData.has_subcontractor === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </span>
          </div>
        </div> */}
      </div>


    </div>
  )
}
export default withTranslation('common')(ProjectitemShowComponent);
